var default_styles_default = {
  "button_container": "Vm-W3",
  "button_margin": "_0DubU",
  "button_text": "OcVFN",
  "button_size_content": "eLY7i"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
